import moment from "moment"
import { Routers } from "../../../../../../../../constant/Routers"
import { AxiosErrorType } from "../../../../../../../../infrastructure/axiosError/models"
import { pushStateError } from "../../../../../../../../utils/pushStateError"
import { commonApi } from "../../../../../apis"
import {
  FilesListDataSourceType,
  GetFilesParamType,
} from "../../../../../models/files/list"
import { useVariablesApi } from "../useVariablesApi"

const { SCR973 } = Routers

export const useApi = () => {
  const {
    fileInfoList,
    initDateTime,
    isDisabledBtnDownload,
    isDisabledBtnPreview,
    isLoading,
    isLoadingLayout,
    onChangePagination,
    onChangeTable,
    perItem,
    push,
    rowSelection,
    selectedRowKeys,
    setFileInfoList,
    setInitDateTime,
    setIsDisabledBtnDownload,
    setIsDisabledBtnPreview,
    setIsLoading,
    setIsLoadingLayout,
    setSelectedRowKeys,
    form,
  } = useVariablesApi()

  const handleGetDataSource = async () => {
    setIsLoading(true)
    setSelectedRowKeys([])
    setIsDisabledBtnDownload(true)
    setIsDisabledBtnPreview(true)
    const { countryCode, fileType } = form.getFieldsValue()
    await getFiles({ countryCode, type: fileType })
  }

  const getFiles = async (params: GetFilesParamType) => {
    // APIを呼び出し、APIからの応答結果を「戻りファイル情報」変数に設定する。
    await commonApi
      .getFiles({
        fileCategory: "1",
        isCountry: true,
        ...params,
      })
      .then((res: FilesListDataSourceType[]) => {
        setFileInfoList(res)
        setInitDateTime(moment())
        setIsLoadingLayout(false)
        setIsLoading(false)
      })
      .catch((error: AxiosErrorType) => {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const stateError = pushStateError(error)
        push({ pathname: SCR973, state: stateError })
      })
  }

  return {
    fileInfoList,
    form,
    getFiles,
    handleGetDataSource,
    initDateTime,
    isDisabledBtnDownload,
    isDisabledBtnPreview,
    isLoading,
    isLoadingLayout,
    onChangePagination,
    onChangeTable,
    perItem,
    rowSelection,
    selectedRowKeys,
  }
}
